import { addUpdatePricing } from '../../../../actions/siteadmin/Pricing/addUpdatePricing';
import { demoRestriction } from '../../../../actions/demoRestriction';

async function submit(values, dispatch) {
    let isActive, isPriceEditable;
    isActive = !values?.isActive || values?.isActive == 'false' ? false : true
    isPriceEditable = !values?.isPriceEditable || values?.isPriceEditable == 'false' ? false : true;

    const isRestrict = await dispatch(demoRestriction({ restrictType: 'fare', restrictValue: values?.id }));
    if (isRestrict) return;
    

    await dispatch(
        addUpdatePricing(
            values.id,
            Number(values.locationId),
            Number(values.categoryId),
            Number(values.subCategoryId),
            isActive,
            values.currency,
            isPriceEditable,
            parseFloat(values.basePrice),
            parseFloat(values.multiplierValue),
        )
    )
}

export default submit;